var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagesmode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_370_583",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_370_583)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 16,
    height: 17,
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 21.5C4.48333 21.5 3.83333 21.2333 3.3 20.7C2.76667 20.1667 2.5 19.5167 2.5 18.75V5.25C2.5 4.48333 2.76667 3.83333 3.3 3.3C3.83333 2.76667 4.48333 2.5 5.25 2.5H18.75C19.5167 2.5 20.1667 2.76667 20.7 3.3C21.2333 3.83333 21.5 4.48333 21.5 5.25V18.75C21.5 19.5167 21.2333 20.1667 20.7 20.7C20.1667 21.2333 19.5167 21.5 18.75 21.5H5.25ZM5.25 20H18.75C19.1 20 19.396 19.879 19.638 19.637C19.8793 19.3957 20 19.1 20 18.75V5.25C20 4.9 19.8793 4.604 19.638 4.362C19.396 4.12067 19.1 4 18.75 4H5.25C4.9 4 4.60433 4.12067 4.363 4.362C4.121 4.604 4 4.9 4 5.25V18.75C4 19.1 4.121 19.3957 4.363 19.637C4.60433 19.879 4.9 20 5.25 20ZM6.6 17.5L10 14.1L11.825 15.9L14 13.15L17.475 17.5H6.6ZM8.25 9.75C7.76667 9.75 7.35433 9.57933 7.013 9.238C6.671 8.896 6.5 8.48333 6.5 8C6.5 7.51667 6.671 7.104 7.013 6.762C7.35433 6.42067 7.76667 6.25 8.25 6.25C8.73333 6.25 9.146 6.42067 9.488 6.762C9.82933 7.104 10 7.51667 10 8C10 8.48333 9.82933 8.896 9.488 9.238C9.146 9.57933 8.73333 9.75 8.25 9.75Z",
    fill: "#0395FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesmode);
export default __webpack_public_path__ + "static/media/imagesmode.ef302e3e3263ac6f1c144626ad869e7c.svg";
export { ForwardRef as ReactComponent };